import { signOut } from 'aws-amplify/auth';

import { AUTH_LOGIN } from '../constants/action-types';

export const failedAuthLogin = () => {
  return {
    type: AUTH_LOGIN,
    isAuthenticated: false,
  };
};

export function authLogout() {
  return function (dispatch: any) {
    signOut()
      .catch(() => {
        // signOut() can reject when the token is already revoked or expired.
        // Swallow the error — we still want to clear local state and redirect.
      })
      .finally(() => {
        dispatch(failedAuthLogin());
        window.location.href = '/';
      });
  };
}
